import { Layout } from 'antd'
import { useEffect } from 'react'
import NavBar from './NavBar'
import { Outlet, useLocation } from 'react-router-dom'

const { Content, Footer } = Layout

export default function Root () {
  const location = useLocation()
  const isHome = location.pathname === '/'
  const isCarbonWorkspace = location.pathname === '/bom' || location.pathname.startsWith('/projects') || location.pathname.startsWith('/carbon-calculator')

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [location.pathname])

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <NavBar />
      <Content style={{ padding: '24px 24px', maxWidth: isCarbonWorkspace || isHome ? 1600 : 1100, margin: '0 auto', width: '100%' }}>
        <Outlet />
      </Content>
      <Footer style={{ textAlign: 'center', color: '#6D6D6D', fontSize: 12, padding: '16px 24px', background: '#F2F2F2' }}>
        Sustainability Tool Kit
      </Footer>
    </Layout>
  )
}
